import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class TpClientInvoiceLineItemSearchParams extends SearchParamsBase {
  static saveType = 'TpClientInvoiceLineItemSearchParams';
  initialize() {
    this.TpClientInvoiceId = '';
    this.Type = '';
  }

}
